import React from 'react';
import RoleForm from '../components/RoleForm';

const RoleFormPage: React.FC = () => <RoleForm />;

export default RoleFormPage;
